import { CSSProperties, ReactNode } from "react";

type TrackerItem = {
  page: string;
  status: "done" | "in_progress" | "pending";
};

export default function ConsoleGuide({
  usageTitle,
  usageText,
  focusTitle,
  focusText,
  tracker,
  style,
}: {
  usageTitle: string;
  usageText: ReactNode;
  focusTitle: string;
  focusText: ReactNode;
  tracker?: TrackerItem[];
  style?: CSSProperties;
}) {
  return (
    <div className="overview-guide-grid" style={style}>
      <div className="home-card overview-guide-card">
        <div className="overview-guide-kicker">How to use this page</div>
        <h3>{usageTitle}</h3>
        <p>{usageText}</p>
      </div>
      <div className="home-card overview-guide-card">
        <div className="overview-guide-kicker">Current focus</div>
        <h3>{focusTitle}</h3>
        <p>{focusText}</p>
      </div>
      {tracker && tracker.length > 0 && (
        <div className="home-card overview-guide-card">
          <div className="overview-guide-kicker">Optimization tracker</div>
          <div className="overview-tracker-list">
            {tracker.map((item, index) => (
              <span
                key={item.page}
                className={`overview-tracker-item ${
                  item.status === "in_progress" ? "is-active" : item.status === "done" ? "is-done" : ""
                }`}
              >
                {index + 1}. {item.page}{" "}
                {item.status === "in_progress" ? "(now)" : item.status === "done" ? "(done)" : "(next)"}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
